import React, { useCallback } from 'react';
import { Flex, Selector, Label, Button, Pane, NumericInput } from '@leverege/ui-elements';
import { Toolbar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import classnames from 'classnames';
import S from './Pagination.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Pagination({
  paginator,
  footerClassName,
  variant,
  context,
  matchContext
}) {
  const onGotoPage = useCallback(({
    value
  }) => {
    paginator.setPage(value, true);
  }, [paginator]);
  const onPreviousPage = useCallback(() => {
    paginator.setPreviousPage();
  }, [paginator]);
  const onNextPage = useCallback(() => {
    paginator.setNextPage();
  }, [paginator]);
  const onSetLimit = useCallback(({
    value
  }) => {
    paginator.setPerPage(value);
  }, [paginator]);
  const totalSize = paginator.count;
  const rangeMin = paginator.displayStartIndex;
  const rangeMax = paginator.displayEndIndex;
  const isInfinite = totalSize === Number.MAX_SAFE_INTEGER;
  const pages = [];
  for (let n = 0; n < paginator.pages; n++) {
    pages.push({
      name: `${n + 1}`,
      value: n
    });
  }
  return /*#__PURE__*/_jsx(Pane, {
    className: classnames(S.content, footerClassName),
    variant: `${variant ? `${variant}|` : ''}tablePagination`,
    children: /*#__PURE__*/_jsxs(Flex, {
      align: "center",
      justify: "space-between",
      className: S.flex,
      children: [/*#__PURE__*/_jsx(Toolbar, {
        variant: "actionBar",
        prefer: "icon",
        matchContext: {
          ...matchContext,
          use: 'footerLeft'
        },
        context: context,
        children: /*#__PURE__*/_jsxs(Flex, {
          align: "center",
          variant: "rowM",
          children: [/*#__PURE__*/_jsx(Label, {
            htmlFor: "limit",
            children: "Per Page"
          }), /*#__PURE__*/_jsx(NumericInput, {
            max: Config.get('DeviceList', 'maxItemsLimit', 9999),
            id: "limit",
            variant: "limit",
            onChange: onSetLimit,
            value: paginator.perPage
          })]
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        align: "center",
        variant: "rowM",
        children: [isInfinite && paginator.hasPreviousPage && /*#__PURE__*/_jsx(Button, {
          variant: "paginationPrev",
          onClick: onPreviousPage,
          className: S.leftArrow
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputCaption|caption",
          children: `${rangeMin} - ${rangeMax}${isInfinite ? '' : ` of ${totalSize}`}`
        }), /*#__PURE__*/_jsxs(Flex, {
          align: "center",
          justify: "center",
          children: [!isInfinite && paginator.hasPreviousPage && /*#__PURE__*/_jsx(Button, {
            variant: "paginationPrev",
            onClick: onPreviousPage,
            className: S.leftArrow
          }), !isInfinite && /*#__PURE__*/_jsx(Selector, {
            dropUp: true,
            variant: "pagination",
            value: paginator.page,
            values: pages,
            onChange: onGotoPage
          }), paginator.hasNextPage && /*#__PURE__*/_jsx(Button, {
            variant: "paginationNext",
            onClick: onNextPage,
            className: S.rightArrow
          })]
        }), matchContext && /*#__PURE__*/_jsx(Toolbar, {
          variant: "actionBar",
          prefer: "icon",
          matchContext: {
            ...matchContext,
            use: 'footerRight'
          },
          context: context
        })]
      })]
    })
  });
}